import React from "react";
import {OverlayTrigger, Tooltip } from "react-bootstrap";

import styles from "./lockIcon.module.scss";

export default function LockIcon() {
  return (
    <div className={styles.lock}>
      <div className={styles.icon}>
        <div className={styles.inner}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip className={styles.toolTip} id="internal-use-only">internal use only</Tooltip>}
          >
            <span className="paperflite-lock" />
          </OverlayTrigger>
        </div>
      </div>
    </div>
  );
}